<template>
  <q-input
    type="number"
    :value="displayValue"
    v-bind="$attrs"
    @input="handleInput"
  />
</template>

<script>
  import Decimal from 'decimal.js'

  export default {
    inject: ['$validator'],

    inheritAttrs: false,
    props: ['value'],
    computed: {
      displayValue () {
        if (typeof this.value !== 'number') {
          return
        }

        return new Decimal(this.value).dividedBy(100).toFixed(2)
      }
    },
    methods: {
      handleInput (val) {
        if (typeof val !== 'number') {
          return
        }

        const value = new Decimal(val).times(100).round().toNumber()
        this.$emit('input', value)
      }
    }
  }
</script>
